import {
  Box,
  Grid,
  IconButton,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React, { FC, useEffect } from "react";
import Brightness4Icon from "@material-ui/icons/Brightness4";
import { useDataProvider, useNotify, UserMenu } from "react-admin";
import CustomLogoutButton from "./CustomLogoutButton";
import TitleBreadcrumb from "../../TitleBreadcrumb";
import { Helmet } from "react-helmet";
import SchoolSelection from "./SchoolSelection";
import { useHistory, useLocation } from "react-router-dom";
import { GetParam, SchoolIdSelected } from "../../../utils/tools";
import { useDispatch } from "react-redux";
import { changeActiveSchool } from "../../../redux/navmode.action";
import AvatarComponent from "./AvatarComponent";
import NotificationButton from "./NotificationButton";

export interface HeaderContentProps {
  breadcrumb: {
    link: string;
    title: string;
    params?: string;
  }[];
  headerTitle: string;
  isNotHaveSchoolFilter?: boolean;
  photoUrl?: string;
}

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  titleBox: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2), // Add some spacing between avatar and text
  },
  title: {
    fontWeight: "bold",
    color: "#2B3674",
  },
  toolboxWrapper: {
    display: "flex",
    gap: 2,
    float: "right",
    backgroundColor: "#FFFFFF",
    boxShadow: "14px 17px 40px 4px rgba(112, 144, 176, 0.08)",
    padding: "5px 15px",
    borderRadius: "30px",
    "& .MuiSvgIcon-root": {
      color: "#5E97D4",
    },
  },
  searchField: {
    width: 200,
    height: "fit-content",
    borderRadius: "30px",
    backgroundColor: "#F4F7FE",
    marginTop: "4px",
    "& .MuiInputBase-root": {
      color: "#2B3674", // Placeholder text color
      "&:hover": {
        border: "0px !important",
      },
    },
    "& .MuiSvgIcon-root": {
      color: "#2B3674", // Search icon color
    },
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        border: 0,
      },
      "&.Mui-focused fieldset": {
        border: 0,
      },
    },
    "& .MuiOutlinedInput-inputAdornedStart": {
      paddingLeft: "5px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent",
    },
    "& input::placeholder": {
      color: "#8F9BBA",
    },
  },
}));

export const setSchoolParams = (
  schoolIdSelected: string,
  history: any,
  location: any,
) => {
  const queryParams = new URLSearchParams(location.search);
  const currentParams = Object.fromEntries(queryParams.entries());
  currentParams.schoolId = schoolIdSelected;

  const queryString = new URLSearchParams(currentParams).toString();
  history.replace({
    pathname: location.pathname,
    search: queryString,
  });
};

const HeaderContent: FC<HeaderContentProps> = ({
  breadcrumb,
  headerTitle,
  isNotHaveSchoolFilter,
  photoUrl,
}) => {
  const history = useHistory();
  const location = useLocation();
  const classes = useStyles();
  const dispatch = useDispatch();
  const provider = useDataProvider();
  const notify = useNotify();

  const schoolIdFromRedux = SchoolIdSelected();
  const param = GetParam();

  const schoolIdFromUrl = param.get("schoolId");

  const getSchoolById = async () => {
    if (
      !schoolIdFromUrl ||
      schoolIdFromUrl === "undefined" ||
      schoolIdFromUrl === "NaN"
    )
      return;

    try {
      const result = await provider.getOne("schools", {
        id: schoolIdFromUrl,
      });

      if (!result) {
        return;
      }

      if (!result.data) {
        notify("School not found", "error");
        return;
      }

      dispatch(changeActiveSchool(result.data));
    } catch (error) {
      notify(`Something went wrong, error: ${error.message}`, "error");
    }
  };

  useEffect(() => {
    if (
      schoolIdFromUrl &&
      schoolIdFromUrl !== "undefined" &&
      schoolIdFromUrl !== "NaN"
    )
      return;

    setSchoolParams(schoolIdFromRedux, history, location);
  }, [schoolIdFromRedux, location.pathname, location.search, history]);

  useEffect(() => {
    if (schoolIdFromUrl === schoolIdFromRedux) return;

    getSchoolById();
  }, [schoolIdFromUrl, schoolIdFromRedux]);

  return (
    <>
      <Helmet>
        <title>{headerTitle}</title>
      </Helmet>

      <Grid
        container
        spacing={2}
        style={{
          marginBottom: isNotHaveSchoolFilter ? "5px" : "15px",
        }}
      >
        <Grid item xs={12} md={6}>
          <Grid container direction="column" spacing={1}>
            <Grid item>
              <TitleBreadcrumb paths={breadcrumb} />
            </Grid>

            <Grid item>
              <Box className={classes.titleBox}>
                {photoUrl ? (
                  <AvatarComponent
                    headerTitle={headerTitle}
                    photoUrl={photoUrl}
                  />
                ) : (
                  <></>
                )}

                <Typography variant="h4" className={classes.title}>
                  {headerTitle}
                </Typography>
              </Box>

              {isNotHaveSchoolFilter ? <></> : <SchoolSelection />}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={6} style={{ alignContent: "center" }}>
          <Box className={classes.toolboxWrapper}>
            {/*<TextField*/}
            {/*  placeholder="Search"*/}
            {/*  size="small"*/}
            {/*  variant="outlined"*/}
            {/*  InputProps={{*/}
            {/*    startAdornment: <SearchIcon fontSize="small" />,*/}
            {/*  }}*/}
            {/*  className={classes.searchField}*/}
            {/*/>*/}

            {/*<NotificationButton />*/}

            {/*<IconButton>*/}
            {/*  <Brightness4Icon />*/}
            {/*</IconButton>*/}

            <UserMenu>
              <CustomLogoutButton />
            </UserMenu>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default HeaderContent;
